/* EBI Toy's Theme – Basis-Skript (Header, Warenkorb, Produkt, Veranstaltungen) */
(function () {
  'use strict';
  var root = window.EBI || {};
  var routes = root.routes || { cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartUpdate: '/cart/update.js', cartJs: '/cart.js' };
  var money = function (cents) {
    var v = (cents / 100).toFixed(2).split('.');
    return v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1] + ' €';
  };

  /* Toast */
  var toastEl;
  function toast(msg, link, isErr) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = '';
    var s = document.createElement('span'); s.textContent = msg; toastEl.appendChild(s);
    if (link) { var a = document.createElement('a'); a.href = link.href; a.textContent = link.label; toastEl.appendChild(a); }
    toastEl.classList.toggle('err', !!isErr);
    toastEl.classList.add('show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 4200);
  }
  root.toast = toast;

  function json(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || 'Fehler'); e.data = d; throw e; } return d; }); });
  }
  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }

  /* Sticky-Kopfzeile: Hinweisleisten scrollen weg, Kopfzeile bleibt */
  var grp = document.querySelector('.shopify-section-group-header-group'), hdr = document.querySelector('.site-header');
  function headerMetrics() {
    if (!hdr) return;
    var pre = grp ? hdr.getBoundingClientRect().top - grp.getBoundingClientRect().top : 0;
    if (grp) grp.style.top = (-pre) + 'px';
    document.documentElement.style.setProperty('--header-h', hdr.offsetHeight + 'px');
  }
  headerMetrics();
  window.addEventListener('resize', headerMetrics);
  if ('ResizeObserver' in window && hdr) new ResizeObserver(headerMetrics).observe(hdr);

  /* Mobiles Menü */
  var toggle = document.querySelector('[data-menu-toggle]'), drawer = document.getElementById('MobileDrawer');
  if (toggle && drawer) {
    toggle.addEventListener('click', function () {
      var open = !drawer.classList.contains('is-open');
      drawer.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) { drawer.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); } });
  }

  /* Mengenfelder (+/−) mit Verpackungseinheit */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]'); if (!b) return;
    var wrap = b.closest('.qty'), input = wrap && wrap.querySelector('input'); if (!input) return;
    var step = parseInt(input.step, 10) || 1, min = parseInt(input.min, 10) || 0, v = parseInt(input.value, 10) || 0;
    v = v + (b.dataset.qtyStep === 'up' ? step : -step);
    if (v < min) v = min;
    input.value = v; input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  function normalizeQty(input) {
    var step = parseInt(input.step, 10) || 1, min = parseInt(input.min, 10) || 0, v = parseInt(input.value, 10) || 0;
    if (v > 0 && step > 1 && v % step) v = Math.ceil(v / step) * step;
    if (v < min) v = min;
    input.value = v; return v;
  }

  /* Produkt: Variantenwahl, Galerie, In den Warenkorb */
  document.querySelectorAll('[data-product]').forEach(function (el) {
    var dataEl = el.querySelector('[data-product-json]'); if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = el.querySelector('form[data-add-form]'), idInput = form && form.querySelector('[name="id"]');
    var selects = el.querySelectorAll('[data-option-index]');
    function current() {
      var opts = [];
      Array.prototype.forEach.call(selects, function (s) {
        var i = parseInt(s.dataset.optionIndex, 10);
        if (s.type === 'radio') { if (s.checked) opts[i] = s.value; } else opts[i] = s.value;
      });
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function update() {
      var v = current(); var btn = form && form.querySelector('[type="submit"]');
      if (!v) { if (btn) { btn.disabled = true; btn.textContent = 'Nicht verfügbar'; } return; }
      if (idInput) idInput.value = v.id;
      var p = el.querySelector('[data-price]'); if (p) p.textContent = money(v.price);
      var c = el.querySelector('[data-compare]'); if (c) { c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      var sku = el.querySelector('[data-sku]'); if (sku) sku.textContent = v.sku || '–';
      var st = el.querySelector('[data-stock]');
      var info = (el.querySelector('[data-stock-map]') ? JSON.parse(el.querySelector('[data-stock-map]').textContent) : {})[v.id];
      if (st && info) { st.textContent = info.label; st.className = 'stock stock--' + info.state; }
      if (info && info.vpe) {
        el.querySelectorAll('[data-vpe]').forEach(function (n) { n.textContent = info.vpe; });
        el.querySelectorAll('[data-min]').forEach(function (n) { n.textContent = info.min; });
        el.querySelectorAll('[data-vpe-row]').forEach(function (n) { n.hidden = info.vpe <= 1; });
        el.querySelectorAll('[data-min-row]').forEach(function (n) { n.hidden = info.min <= 1; });
        var note = el.querySelector('[data-step-note]'); if (note) note.hidden = info.vpe <= 1;
        var k = info.karton || 0;
        el.querySelectorAll('[data-karton]').forEach(function (n) { n.textContent = k; });
        el.querySelectorAll('[data-karton-row]').forEach(function (n) { n.hidden = k <= 0; });
        var kb = el.querySelector('[data-karton-btn]'); if (kb) kb.hidden = k <= 0;
        var q = form && form.querySelector('[name="quantity"]');
        if (q) { q.step = info.vpe; q.min = info.min; q.value = info.min; }
      }
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : 'Ausverkauft'; }
      if (v.featured_media) showMedia(String(v.featured_media.id));
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    function showMedia(id) {
      var btn = el.querySelector('[data-thumb="' + id + '"]'); if (btn) btn.click();
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    var kbtn = el.querySelector('[data-karton-btn]');
    if (kbtn) kbtn.addEventListener('click', function () {
      var q = form && form.querySelector('[name="quantity"]'); var k = parseInt((kbtn.querySelector('[data-karton]') || {}).textContent, 10);
      if (q && k > 0) { q.value = k; normalizeQty(q); q.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    el.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        var main = el.querySelector('[data-main-img]'); if (!main) return;
        main.src = b.dataset.src; main.srcset = b.dataset.srcset || ''; main.alt = b.dataset.alt || '';
        el.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
      });
    });
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = form.querySelector('[name="quantity"]'); var qty = q ? normalizeQty(q) : 1;
        var btn = form.querySelector('[type="submit"]'); btn.classList.add('is-busy');
        json(routes.cartAdd, { items: [{ id: parseInt(idInput.value, 10), quantity: qty }] })
          .then(function () { return json(routes.cartJs); })
          .then(function (cart) { setCount(cart.item_count); toast(qty + ' × im Warenkorb', { href: routes.cart, label: 'Zum Warenkorb' }); })
          .catch(function (err) { toast(err.message || 'Konnte nicht hinzugefügt werden', null, true); })
          .then(function () { btn.classList.remove('is-busy'); });
      });
    }
  });

  /* Schnell-Hinzufügen auf Produktkarten */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-quick-add]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]'); btn.classList.add('is-busy');
    var qty = parseInt(f.querySelector('[name="quantity"]').value, 10) || 1;
    json(routes.cartAdd, { items: [{ id: parseInt(f.querySelector('[name="id"]').value, 10), quantity: qty }] })
      .then(function () { return json(routes.cartJs); })
      .then(function (cart) { setCount(cart.item_count); toast(qty + ' × im Warenkorb', { href: routes.cart, label: 'Zum Warenkorb' }); })
      .catch(function (err) { toast(err.message || 'Konnte nicht hinzugefügt werden', null, true); })
      .then(function () { btn.classList.remove('is-busy'); });
  });

  /* Veranstaltungen: Vergangenes clientseitig ausblenden (Cache-Schutz) */
  var today = new Date(); var todayStr = today.getFullYear() + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + String(today.getDate()).padStart(2, '0');
  document.querySelectorAll('[data-event-deadline]').forEach(function (n) {
    var d = n.getAttribute('data-event-deadline');
    if (d && d < todayStr) { if (n.tagName === 'OPTION') n.remove(); else n.remove(); }
  });
  document.querySelectorAll('[data-events-list]').forEach(function (l) {
    if (!l.querySelector('[data-event-deadline]')) { var e = l.parentNode.querySelector('[data-events-empty]'); if (e) e.hidden = false; }
  });

  /* Veranstaltung vormerken (Kalender → Warenkorbattribute) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-event-pick]'); if (!b) return;
    e.preventDefault();
    b.classList.add('is-busy');
    json(routes.cartUpdate, { attributes: { 'Lieferart': 'Lieferung zur Veranstaltung', 'Veranstaltung': b.dataset.label, 'Veranstaltung_Datum': b.dataset.date, 'Veranstaltung_ID': b.dataset.id } })
      .then(function () { toast('Vorgemerkt: ' + b.dataset.name, { href: b.getAttribute('href') || '/collections/all', label: 'Ware auswählen' }); })
      .catch(function () { toast('Das hat nicht geklappt. Bitte im Warenkorb auswählen.', null, true); })
      .then(function () { b.classList.remove('is-busy'); });
  });

  /* Warenkorb */
  var cartRoot = document.querySelector('[data-cart-root]');
  if (cartRoot) initCart(cartRoot);
  function initCart(rootEl) {
    var sectionId = rootEl.dataset.sectionId;
    function rerender(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-cart-root]');
      if (fresh) { rootEl.replaceWith(fresh); rootEl = fresh; bind(); }
    }
    function change(line, qty) {
      rootEl.classList.add('is-busy');
      json(routes.cartChange, { line: line, quantity: qty, sections: [sectionId], sections_url: location.pathname })
        .then(function (d) { setCount(d.item_count); if (d.sections && d.sections[sectionId]) rerender(d.sections[sectionId]); else location.reload(); })
        .catch(function (err) { toast(err.message || 'Menge konnte nicht geändert werden', null, true); rootEl.classList.remove('is-busy'); });
    }
    var saveT;
    function saveAttrs() {
      clearTimeout(saveT);
      saveT = setTimeout(function () {
        var form = rootEl.querySelector('form[data-cart-form]'); if (!form) return;
        var method = form.querySelector('[name="attributes[Lieferart]"]:checked');
        var sel = form.querySelector('[data-event-select]');
        var opt = sel && sel.selectedOptions[0];
        var isEvent = method && method.value === 'Lieferung zur Veranstaltung';
        var note = form.querySelector('[name="note"]');
        json(routes.cartUpdate, {
          note: note ? note.value : undefined,
          attributes: {
            'Lieferart': method ? method.value : '',
            'Veranstaltung': isEvent && opt && opt.value ? opt.value : '',
            'Veranstaltung_Datum': isEvent && opt && opt.value ? opt.dataset.date : '',
            'Veranstaltung_ID': isEvent && opt && opt.value ? opt.dataset.id : ''
          }
        }).catch(function () {});
      }, 250);
    }
    function syncEventField() {
      var form = rootEl.querySelector('form[data-cart-form]'); if (!form) return;
      var method = form.querySelector('[name="attributes[Lieferart]"]:checked');
      var wrap = form.querySelector('[data-event-wrap]');
      var isEvent = !!(method && method.value === 'Lieferung zur Veranstaltung');
      if (wrap) wrap.hidden = !isEvent;
      var sel = form.querySelector('[data-event-select]'), opt = sel && sel.selectedOptions[0];
      if (sel) sel.disabled = !isEvent;
      form.querySelectorAll('[data-event-blank]').forEach(function (h) { h.disabled = isEvent; });
      var hd = form.querySelector('[data-event-date]'), hi = form.querySelector('[data-event-id]');
      if (hd) { hd.disabled = !isEvent; hd.value = opt && opt.value ? (opt.dataset.date || '') : ''; }
      if (hi) { hi.disabled = !isEvent; hi.value = opt && opt.value ? (opt.dataset.id || '') : ''; }
      var hint = form.querySelector('[data-checkout-hint]');
      if (hint && method) hint.textContent = method.dataset.hint || '';
    }
    function bind() {
      rootEl.querySelectorAll('[data-line-qty]').forEach(function (inp) {
        inp.addEventListener('change', function () { change(parseInt(inp.dataset.lineQty, 10), normalizeQty(inp)); });
      });
      rootEl.querySelectorAll('[data-line-remove]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); change(parseInt(b.dataset.lineRemove, 10), 0); });
      });
      var form = rootEl.querySelector('form[data-cart-form]'); if (!form) return;
      form.querySelectorAll('[name="attributes[Lieferart]"], [data-event-select], [name="note"]').forEach(function (i) {
        i.addEventListener('change', function () { syncEventField(); saveAttrs(); });
      });
      syncEventField();
      form.addEventListener('submit', function (e) {
        var sub = e.submitter;
        if (!sub || sub.name !== 'checkout') return;
        var err = '';
        var method = form.querySelector('[name="attributes[Lieferart]"]:checked');
        var sel = form.querySelector('[data-event-select]');
        var min = parseInt(form.dataset.minOrder || '0', 10), total = parseInt(form.dataset.total || '0', 10);
        if (!method) err = 'Bitte wähle eine Lieferart.';
        else if (method.value === 'Lieferung zur Veranstaltung' && (!sel || !sel.value)) err = 'Bitte wähle die Veranstaltung, zu der wir liefern sollen.';
        else if (min && total < min) err = 'Der Mindestbestellwert beträgt ' + money(min) + '.';
        if (err) { e.preventDefault(); toast(err, null, true); var box = form.querySelector('[data-delivery]'); if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (method.value === 'Lieferung zur Veranstaltung') { e.preventDefault(); goEventCheckout(form, sel, sub); }
      });
    }
    /* Lieferung zur Veranstaltung: Festplatz-Adresse direkt im Checkout vorausfüllen (Cart-Permalink mit checkout[shipping_address]) */
    function goEventCheckout(form, sel, btn) {
      var opt = sel.selectedOptions[0], note = form.querySelector('[name="note"]');
      var attrs = { 'Lieferart': 'Lieferung zur Veranstaltung', 'Veranstaltung': opt.value, 'Veranstaltung_Datum': opt.dataset.date || '', 'Veranstaltung_ID': opt.dataset.id || '' };
      var fallback = function () { var h = document.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; form.appendChild(h); form.submit(); };
      if (btn) btn.classList.add('is-busy');
      clearTimeout(saveT);
      json(routes.cartUpdate, { attributes: attrs, note: note ? note.value : undefined })
        .then(function () { return json(routes.cartJs); })
        .then(function (cart) {
          var plain = cart.items.length && cart.items.every(function (it) { return !it.selling_plan_allocation && (!it.properties || !Object.keys(it.properties).length); });
          if (!plain) return fallback();
          var p = new URLSearchParams();
          var ad = function (k, v) { if (v) p.append('checkout[shipping_address][' + k + ']', v); };
          if (form.dataset.email) p.append('checkout[email]', form.dataset.email);
          ad('first_name', form.dataset.first); ad('last_name', form.dataset.last);
          ad('address1', opt.dataset.street || ('Festplatz ' + (opt.dataset.name || '')));
          ad('address2', 'Veranstaltung: ' + (opt.dataset.name || opt.value) + (opt.dataset.date ? ' (' + opt.dataset.date + ')' : ''));
          ad('zip', opt.dataset.zip); ad('city', opt.dataset.city); ad('country', 'DE');
          Object.keys(attrs).forEach(function (k) { p.append('attributes[' + k + ']', attrs[k]); });
          if (cart.note) p.append('note', cart.note);
          var lines = cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(',');
          location.href = '/cart/' + lines + '?' + p.toString();
        })
        .catch(fallback);
    }
    bind();
  }
})();
